import React, { useMemo } from "react";
import { Validating } from "./Validating";
import { Unauthenticated } from "./Unauthenticated";
import { Authorizations } from "../types";
import {
  getGoogleUserManager,
  getAzureUserManager,
  OidcProvider,
} from "../oidcUserManagers";

export type AuthenticationManagerContextData = {
  jwt: string | null;
  authorizations: Authorizations | null;
  provider: OidcProvider | null;
  dispatch: React.Dispatch<any>;
};

export const AuthenticationManagerContext =
  React.createContext<AuthenticationManagerContextData | null>(null);

type AuthenticationManagerDisplayProps = {
  isAuthenticated: boolean;
  loading: boolean;
  error: boolean;
  jwt: string | null;
  authorizations: Authorizations | null;
  provider: OidcProvider | null;
  dispatch: React.Dispatch<any>;
};

export const AuthenticationManagerDisplay: React.FC<
  AuthenticationManagerDisplayProps
> = ({
  isAuthenticated,
  loading,
  error,
  jwt,
  authorizations,
  provider,
  dispatch,
  children,
}) => {
  const contextValue: AuthenticationManagerContextData = useMemo(
    () => ({ jwt, authorizations, provider, dispatch }),
    [jwt, authorizations, provider, dispatch]
  );

  if (isAuthenticated) {
    return (
      <AuthenticationManagerContext.Provider value={contextValue}>
        {children}
      </AuthenticationManagerContext.Provider>
    );
  }

  if (loading) {
    return <Validating />;
  }

  const doGoogleRedirect = () => {
    void getGoogleUserManager().signinRedirect({
      state: window.location.pathname,
    });
  };

  const doAzureRedirect = () => {
    void getAzureUserManager().signinRedirect({
      state: window.location.pathname,
    });
  };

  return (
    <Unauthenticated
      doGoogleRedirect={doGoogleRedirect}
      doAzureRedirect={doAzureRedirect}
      problem={error}
    />
  );
};
